import {Component, Input, OnInit} from '@angular/core';
import {ApiService} from '../../../../services/api.service';
import {ErrorService} from '../../../../services/error.service';
import {SweetalertService} from '../../../../services/sweetalert.service';
import {AuthService} from '../../../../services/auth.service';
import {AbstractControl, FormArray, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import Swal from 'sweetalert2';
import {ProposalModel} from '../../../../models/requests/proposal/proposal.model';
import {AuthorModel} from '../../../../models/requests/author/author.model';
import {MembershipModel} from '../../../../models/requests/membership/membership.model';
import {PublisherModel} from '../../../../models/requests/publisher/publisher.model';
import {PublicationModel} from '../../../../models/requests/publication/publication.model';
import {PublicationCostModel} from '../../../../models/requests/publicationCost/publicationCost.model';


@Component({
  selector: 'app-proposal-edit',
  templateUrl: './proposal-edit.component.html',
  styleUrls: ['./proposal-edit.component.scss']
})
export class ProposalEditComponent implements OnInit {
  @Input() public proposal;

  public isLoading;
  public selectedPool = null;
  public stage1: FormGroup = this.formBuilder.group({
    pool: [null, Validators.required],
  });
  public stage2: FormGroup = this.formBuilder.group({
    id: [null],
    poolPublicationType: [null, Validators.required],
    amountFunding: [null, Validators.required],
    publishTitle: [null, Validators.required],
    isbn: [null, [Validators.required, this.ValidatorISBN()]],
    authors: this.formBuilder.array([]),
    publisher: this.formBuilder.array([])
  });
  public stage3: FormGroup = this.formBuilder.group({
    authors: this.formBuilder.array([]),
    publisher: this.formBuilder.array([]),
  });
  public stage4: FormGroup = this.formBuilder.group({
    id: [null],
    authorPublishings: this.formBuilder.array([]),
    publisherPublishings: this.formBuilder.array([]),
    descriptionPublication: [null, Validators.required],
    justificationPublishing: [null, Validators.required],
    descriptionCreativeActivityApplicant: [null, Validators.required],
  });
  public stage5: FormGroup = this.formBuilder.group({
    id: [null],
    author: [null, Validators.required],
    title: [null, Validators.required],
    publisher: [null, Validators.required],
    isbn: [null, [Validators.required, this.ValidatorISBN()]],
    publish_date: [null, Validators.required],
    amount_funding: [null, Validators.required],
    publishing_sheets: [null, Validators.required],
    number_pages: [null, Validators.required],
    number_illustrations: [null, Validators.required],
    isbn_publication: [null, Validators.required],
    book_form: [null, Validators.required],
    preparation_for_printing: [null, Validators.required],
    publisher_cost: [null, Validators.required],
    copyright_fee: [null, Validators.required],
    retail_price: [null, Validators.required],
    print_run: [null, Validators.required],
    is_publication_finished: [null, Validators.required],
    billing_date_for_request: [null, Validators.required],
  });
  public stage7: FormGroup = this.formBuilder.group({
    consentOne: [null, Validators.required],
    consentTwo: [null, Validators.required],
    consentThree: [null, Validators.required],
  });
  public draft;
  public isErrorPesel = false;
  public isErrorNip = false;
  public fileToUpload: File = null;
  public files = [];
  public typesPublication = [];
  public maximumAmountForType = 0;
  public invalidAmountFunding = true;
  private observer: any = new Subject();
  public pools = this.observer.asObservable();

  constructor(private apiService: ApiService,
              private errorService: ErrorService,
              private sweetalertService: SweetalertService,
              private authService: AuthService,
              public formBuilder: FormBuilder
  ) {
  }

  get authors(): FormArray {
    return this.stage2.get('authors') as FormArray;
  }

  get publisher(): FormArray {
    return this.stage2.get('publisher') as FormArray;
  }

  get authorsMembership(): FormArray {
    return this.stage3.get('authors') as FormArray;
  }

  get publisherMembership(): FormArray {
    return this.stage3.get('publisher') as FormArray;
  }

  get authorPublishings(): FormArray {
    return this.stage4.get('authorPublishings') as FormArray;
  }

  get publisherPublishings(): FormArray {
    return this.stage4.get('publisherPublishings') as FormArray;
  }

  nipValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value === '' || control.value == null) {
        return null;
      }

      let nip = control.value;

      if (nip.length != 10) {
        return {notNip: {value: control.value}};
      }

      nip = nip.replace(/[\ \-]/gi, '');

      const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      let sum = 0;
      const controlNumber = parseInt(nip.substring(9, 10));
      const weightCount = weight.length;

      for (let i = 0; i < weightCount; i++) {
        sum += (parseInt(nip.substr(i, 1)) * weight[i]);
      }

      if (sum % 11 != controlNumber) {
        return {nip: {value: control.value}};
      }

      return null;
    };
  }


  ValidatorISBN(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }

      const regex = /^(?:ISBN(?:-13)?:?\ )?(?=[0-9]{13}$|(?=(?:[0-9]+[-\ ]){4})[-\ 0-9]{17}$)97[89][-\ ]?[0-9]{1,5}[-\ ]?[0-9]+[-\ ]?[0-9]+[-\ ]?[0-9]$/;

      if (regex.test(control.value)) {
        return null;
      }

      return {ISBN: {value: control.value}};
    };
  }

  validatorPhone(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }

      const regex = /[- +()0-9]{9,}/;

      if (regex.test(control.value)) {
        return null;
      }

      return {phone: {value: control.value}};
    };
  }


  validatorPesel(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      // const forbidden = nameRe.test(control.value);
      // return forbidden ? {forbiddenName: {value: control.value}} : null;
      if (control.value === '' || control.value == null) {
        return null;
      }

      const pesel = control.value;
      const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
      let sum = 0;
      const controlNumber = parseInt(pesel.substring(10, 11));

      for (let i = 0; i < weight.length; i++) {
        // tslint:disable-next-line:radix
        sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
      }
      sum = sum % 10;
      const isValid = (10 - sum) % 10 === controlNumber;

      if (isValid) {
        return null;
      }

      return {pesel: {value: control.value}};
    };
  }

  ngOnInit(): void {
    this.loadPools();
    this.pools.subscribe(data => {
      this.stage1.patchValue(
        {
          pool: this.proposal.pool.id
        }
      );
      this.getTypesPublicationForPool(this.stage1.controls.pool.value);
      this.stage2.patchValue(this.proposal);
      this.stage3.patchValue(this.proposal);
      this.stage4.patchValue(this.proposal);

      this.proposal.authors.forEach(item => {
        this.addAuthor(item);
      });


      this.proposal.publishers.forEach(item => {
        this.addPublisher(item);
      });

      this.proposal.previousPublisherPublications.forEach(item => {
        this.addPublisherPublishings(item);
      });

      this.proposal.previousAuthorPublications.forEach(item => {
        this.addAuthorPublishings(item);
      });

      if (this.proposal.publicationCosts.length == 1) {
        this.stage5.patchValue(this.proposal.publicationCosts[0]);
      }
    });

  }

  public buildAuthor(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      name: [null, Validators.required],
      lastname: [null, Validators.required],
      nickname: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, this.validatorPhone()]],
      pesel: [null, [Validators.required, this.validatorPesel()]],
      street: [null, Validators.required],
      post_code: [null, Validators.required],
      city: [null, Validators.required],
      country: [null, Validators.required],
    });
  }

  public buildPublisher(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      publisher_name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, this.validatorPhone()]],
      street: [null, Validators.required],
      post_code: [null, Validators.required],
      city: [null, Validators.required],
      country: [null, Validators.required],
      publisher_nip: [null, [Validators.required, this.nipValidator()]],
      krs_ceidg: [null, Validators.required],
    });
  }

  public buildAuthorMembership(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      is_member_association: [false, Validators.required],
      is_contract_concluded: [false, Validators.required],
    });
  }

  public buildPublisherMembership(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      is_member_association: [false, Validators.required],
      is_contract_concluded: [false, Validators.required],
    });
  }

  public buildAuthorPublishings(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      author: [null, Validators.required],
      title: [null, Validators.required],
      isbn: [null, [Validators.required, this.ValidatorISBN()]],
      publisher: [null, Validators.required],
      publish_date: [null, [Validators.required, Validators.min(1950), Validators.max(new Date().getFullYear())]],
      role_in_publication: [null, Validators.required],
      is_reported_plr: [false, Validators.required],
      is_reported_sub_contract: [false, Validators.required],
      is_reported_membership_declaration: [false, Validators.required],
    });
  }

  public buildPublisherPublishings(): FormGroup {
    return this.formBuilder.group({
      id: [null],
      author: [null, Validators.required],
      title: [null, Validators.required],
      isbn: [null, [Validators.required, this.ValidatorISBN()]],
      publisher: [null, Validators.required],
      publish_date: [null, [Validators.required, Validators.min(1950), Validators.max(new Date().getFullYear())]],
      role_in_publication: [null, Validators.required],
      is_reported_plr: [false, Validators.required],
      is_reported_sub_contract: [false, Validators.required],
      is_reported_membership_declaration: [false, Validators.required],
    });
  }

  addAuthor(author = null): void {
    this.addAuthorMembership(author);
    const form = this.buildAuthor();
    if (author != null) {
      form.patchValue(author);
    }

    this.authors.push(form);
  }

  addPublisher(publisher = null): void {
    this.addPublisherMembership(publisher);
    const form = this.buildPublisher();
    if (publisher !== null) {
      form.patchValue(publisher);
    }

    this.publisher.push(form);
  }

  addAuthorMembership(author = null): void {

    const form = this.buildAuthorMembership();
    if (author != null) {
      form.patchValue(author.memberships[0]);
    }
    this.authorsMembership.push(form);
  }

  addPublisherMembership(publisher = null): void {
    const form = this.buildPublisherMembership();
    if (publisher != null) {
      form.patchValue(publisher.memberships[0]);
    }
    this.publisherMembership.push(form);
  }

  addAuthorPublishings(publication = null): void {
    const form = this.buildAuthorPublishings();
    if (publication != null) {
      form.patchValue(publication);
    }
    this.authorPublishings.push(form);
  }

  addPublisherPublishings(publication = null): void {
    const form = this.buildPublisherPublishings();
    if (publication != null) {
      form.patchValue(publication);
    }
    this.publisherPublishings.push(form);
  }

  public deleteAuthor(i) {
    this.authors.removeAt(i);
    this.authorsMembership.removeAt(i);
  }

  public deleteAuthorPublishing(i) {
    this.authorPublishings.removeAt(i);
  }

  public deletePublisherPublishing(i) {
    this.publisherPublishings.removeAt(i);
  }

  public removeStage(index) {
    const arrayControl = this.stage2.controls.authors as FormArray;
    arrayControl.removeAt(index);
  }

  public validAmountFunding(event) {
    if (event.target.value > this.maximumAmountForType) {
      this.invalidAmountFunding = true;
      return;
    }
    this.invalidAmountFunding = false;
  }



  public changeFormGroupStatusForAuthor(publicationNumber) {
    //this.form.controls['name'].disable();
    const formArray = this.stage4.get('authorPublishings') as FormArray
    const form = formArray.at(publicationNumber) as FormGroup;
    this._setPublishingFieldsStatus(form);
  }

  public changeFormGroupStatusForPublisher(publicationNumber) {
    //this.form.controls['name'].disable();
    const formArray = this.stage4.get('publisherPublishings') as FormArray
    const form = formArray.at(publicationNumber) as FormGroup;
    this._setPublishingFieldsStatus(form);
  }

  public loadPools() {
    this.isLoading = true;
    this.apiService.getAcceptedPools().subscribe((response: any) => {
      this.isLoading = false;
      this.observer.next(response.data);
    }, error => {
      this.sweetalertService.connectionError();
    });
  }

  public selectedPublicationType(type) {
    if (type !== null) {
      for (let i = 0; i < this.typesPublication.length; i++) {
        if (this.typesPublication[i].id == type) {
          this.maximumAmountForType = this.typesPublication[i].maximumAmountAwards;
        }
      }
    }
  }

  public getTypesPublicationForPool(pool) {
    this.isLoading = true;
    if (typeof pool === 'object' && pool !== null) {
      pool = pool.id;
    }
    this.apiService.getPoolPublicationTypesForPool(pool).subscribe((response: any) => {
      this.isLoading = false;
      this.typesPublication = response.data;
      this.maximumAmountForType = response.data.maximumAmountAwards;
    }, error => {
      this.sweetalertService.connectionError();
    });
  }

  public setSelectedPool(pool) {
    this.selectedPool = pool;
    this.getTypesPublicationForPool(pool);
  }

  public saveDraft($event) {

  }

  public isValidPesel(pesel) {
    const weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum = 0;
    const controlNumber = parseInt(pesel.substring(10, 11));

    for (let i = 0; i < weight.length; i++) {
      sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
    }
    sum = sum % 10;
    this.isErrorPesel = (10 - sum) % 10 !== controlNumber;

    if (this.isErrorPesel === true) {
      this.authors.controls['pesel'].setErrors({'incorrect': true})
    }
  }

  public isValidNip(nip) {
    nip = nip.replace(/[\ \-]/gi, '');

    const weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    const controlNumber = parseInt(nip.substring(9, 10));
    const weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
      sum += (parseInt(nip.substr(i, 1)) * weight[i]);
    }

    this.isErrorNip = sum % 11 !== controlNumber;

    if (this.isErrorNip === true) {
      this.publisher.controls['nip'].setErrors({'incorrect': true})
    }
  }

  public formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  public uploadFile(files: FileList) {
    this.fileToUpload = files.item(0);

    this.apiService.postFile(this.fileToUpload).subscribe((response: any) => {
      this.files.push(response.data);
      this.fileToUpload = null;
    }, error => {
      this.errorService.handleError(error);
      this.fileToUpload = null;
    })
  }

  public sendProposal(e) {
    if (this.stage2.controls.amountFunding.value > this.maximumAmountForType) {
      this.sweetalertService.formError('Podałeś za dużą kwotę dofinansowania. Maksymalna kwota dofinansowania w tej puli dla wybranego typu publikacji to ' + this.maximumAmountForType + 'PLN');
      e.preventDefault();
      return;
    }
    const proposal: ProposalModel = {
      id: this.proposal.id,
      pool: this.stage1.controls.pool.value,
      poolPublicationType: this.stage2.controls.poolPublicationType.value['id'],
      amountFunding: this.stage2.controls.amountFunding.value,
      publishTitle: this.stage2.controls.publishTitle.value,
      isbn: this.stage2.controls.isbn.value,
      descriptionPublication: this.stage4.controls.descriptionPublication.value,
      justificationPublishing: this.stage4.controls.justificationPublishing.value,
      status: 0,
      descriptionCreativeActivityApplicant: this.stage4.controls.descriptionCreativeActivityApplicant.value,
    };

    this.apiService.putProposal(proposal).subscribe((response: any) => {

      this.stage2.controls['authors'].value.forEach((item, i) => {
        const author: AuthorModel = {
          id: item.id,
          proposal: this.proposal.id,
          name: item.name,
          lastname: item.lastname,
          nickname: item.nickname,
          email: item.email,
          pesel: item.pesel,
          postCode: item.post_code,
          city: item.city,
          street: item.street,
          country: item.country,
          phone: item.phone
        };
        this.apiService.putAuthor(author).subscribe((authorResponse: any) => {
          const membership: MembershipModel = {
            author: authorResponse.data.id,
            publisher: 0,
            memberAssociation: this.stage3.controls.authors.value[i].is_member_association,
            contractConcluded: this.stage3.controls.authors.value[i].is_contract_concluded
          };
          this.apiService.putMembership(membership).subscribe((membershipResponse: any) => {
          });
        });
      });

      this.stage2.controls['publisher'].value.forEach((item, i) => {
        const publisher: PublisherModel = {
          proposal: this.proposal.id,
          id: item.id,
          email: item.email,
          publisherName: item.publisher_name,
          postCode: item.post_code,
          city: item.city,
          street: item.street,
          country: item.country,
          phone: item.phone,
          publisherNip: item.publisher_nip,
          krsCeidg: item.krs_ceidg,
        };

        this.apiService.putPublisher(publisher).subscribe((publisherResponse: any) => {
          const membership: MembershipModel = {
            author: 0,
            id: item.id,
            publisher: publisherResponse.data.id,
            memberAssociation: this.stage3.controls.publisher.value[i].is_member_association,
            contractConcluded: this.stage3.controls.publisher.value[i].is_contract_concluded
          };
          this.apiService.putMembership(membership).subscribe((membershipResponse: any) => {
          });
        });
      });

      this.stage4.controls['authorPublishings'].value.forEach((item, i) => {
        const publication: PublicationModel = {
          proposal: this.proposal.id,
          id: item.id,

          author: item.author,
          publisher: item.publisher,
          title: item.title,
          isbn: item.isbn,
          publishDate: item.publishDate,
          roleInPublication: item.roleInPublication,
          reportedPlr: item.reportedPlr,
          reportedSubContract: item.reportedSubContract,
          reportedMembershipDeclaration: item.reportedMembershipDeclaration
        };
        this.apiService.putAuthorPublication(publication).subscribe((authorPublicationResponse: any) => {
        });
      });

      this.stage4.controls['publisherPublishings'].value.forEach((item, i) => {
        const publication: PublicationModel = {
          proposal: this.proposal.id,
          id: item.id,

          author: item.author,
          publisher: item.publisher,
          title: item.title,
          isbn: item.isbn,
          publishDate: item.publishDate,
          roleInPublication: item.roleInPublication,
          reportedPlr: item.reportedPlr,
          reportedSubContract: item.reportedSubContract,
          reportedMembershipDeclaration: item.reportedMembershipDeclaration
        };
        this.apiService.putPublisherPublication(publication).subscribe((publisherPublicationResponse: any) => {
        });
      });

      const stage5: PublicationCostModel = {
        proposal: this.proposal.id,
        // id: item.id,

        author: this.stage5.controls.author.value,
        publisher: this.stage5.controls.publisher.value,
        title: this.stage5.controls.title.value,
        isbn: this.stage5.controls.isbn.value,
        publishDate: this.stage5.controls.publishDate.value,
        amountFunding: this.stage5.controls.amountFunding.value,
        publishingSheets: this.stage5.controls.publishingSheets.value,
        numberPages: this.stage5.controls.numberPages.value,
        numberIllustrations: this.stage5.controls.numberIllustrations.value,
        isbnPublication: this.stage5.controls.isbnPublication.value,
        bookForm: this.stage5.controls.bookForm.value.toString(),
        preparationForPrinting: this.stage5.controls.preparationForPrinting.value,
        publisherCost: this.stage5.controls.publisherCost.value,
        copyrightFee: this.stage5.controls.copyrightFee.value,
        retailPrice: this.stage5.controls.retailPrice.value,
        printRun: this.stage5.controls.printRun.value,
        publicationFinished: this.stage5.controls.publicationFinished.value,
        billingDateForRequest: this.formatDate(this.stage5.controls.billingDateForRequest.value),
      };

      this.apiService.putPublicationCost(stage5).subscribe((publicationCostResponse: any) => {
      });

      this.isLoading = false;
    });
  }

  private _setPublishingFieldsStatus(form: FormGroup) {
    if (form.get('reportedPlr').value == true || form.get('reportedSubContract').value == true) {
      form.get('author').disable();
      form.get('title').disable();
      form.get('isbn').disable();
      form.get('publisher').disable();
      form.get('publishDate').disable();
      form.get('roleInPublication').disable();
    } else {
      form.get('author').enable();
      form.get('title').enable();
      form.get('isbn').enable();
      form.get('publisher').enable();
      form.get('publishDate').enable();
      form.get('roleInPublication').enable();
    }
  }
}
